module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-layout', [_c('div', {
    staticClass: "backgroundtexture"
  }), (_vm.container) ? _c('div', {
    staticClass: "credits"
  }, [_c('div', {
    staticClass: "bloctitre"
  }, [_vm._v(_vm._s(_vm.container.titre)), _c('hr', {
    staticClass: "mv1"
  }), _c('span', {
    staticClass: "f4"
  }, [_vm._v("Dreaming of a Jewish Christmas")])]), _vm._l((_vm.container.medias), function(med) {
    return _c('div', {
      staticClass: "soustitre"
    }, [(med.image) ? _c('div', [_c('img', {
      attrs: {
        "src": med.image.thumbnail,
        "width": "90%",
        "height": "90%"
      }
    })]) : _vm._e()])
  }), _c('div', {
    staticClass: "blocdescriptioncredits"
  }, [_c('div', {
    staticClass: "blocdecontenucredits",
    staticStyle: {
      "height": "85%",
      "overflow": "scroll"
    },
    attrs: {
      "id": "blocdecontenu"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.container.description)
    }
  }, [_c('q-fixed-position', {
    attrs: {
      "corner": "bottom-right",
      "offset": [18, 18]
    }
  }, [_c('q-btn', {
    directives: [{
      name: "back-to-top",
      rawName: "v-back-to-top.animate",
      value: ({
        offset: 50,
        duration: 200
      }),
      expression: "{offset: 50, duration: 200}",
      modifiers: {
        "animate": true
      }
    }],
    staticClass: "fa fa-arrow-up animate-pop",
    staticStyle: {
      "margin": "0 48% 100px 0"
    },
    attrs: {
      "round": "round",
      "color": "negative"
    },
    on: {
      "click": function($event) {
        _vm.scrollToTop()
      }
    }
  })], 1)], 1), _c('div', {
    attrs: {
      "id": "findescredits"
    }
  })])], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a89e183c","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Film/Credits.vue
// module id = 1289
// module chunks = 1